export function ourFeaturesFlicking() {
    if (!!document.querySelector('#our-features-flick') === false) return;

    const flicking = new Flicking('#our-features-flick', {
        circular: true,
        horizontal: false,
        align: 'center',
        inputType: ['pointer'],
    });
    flicking.addPlugins(new Flicking.Plugins.AutoPlay());

    // Mobile animation
    if (window.innerWidth < 960) {
        const slidesInView = 5; // max number of visible slides for opacity scale, based on css height of elements

        function setMobileStyles() {
            const avgPanelSize = flicking.panels.reduce((sum, p) => sum + p.size, 0) / flicking.panels.length;

            // Camera center is simply: current position + half of visible viewport
            const cameraCenter = flicking.camera.position + flicking.camera.size / 2 + 60;

            // Distance threshold - items within this range get styled
            const maxDistance = (avgPanelSize * (slidesInView + 2)) / 2;

            flicking.panels.forEach((panel) => {
                const item = panel.element.querySelector('.our-features-line') || panel.element;
                const panelCenter = panel.position + panel.size / 2;

                // Compute raw offset from camera center
                let offset = panelCenter - cameraCenter;

                // Wrap offset for circular mode
                if (flicking.circular) {
                    const totalWidth = flicking.camera.range.max - flicking.camera.range.min;

                    // Normalize offset to range [0, -totalWidth]
                    if (offset > 0) {
                        offset = offset - totalWidth;
                    } else if (offset < -totalWidth) {
                        offset = offset + totalWidth;
                    }
                }

                // Normalized distance: 0 at center, 1 at maxDistance boundary
                const normalizedDistance = Math.abs(offset) / maxDistance;

                // Linear fade: 1 (center) to 0.3 (edges)
                const opacity = 1 - normalizedDistance * 0.5;

                const scale = 1.2 - normalizedDistance * 0.2;

                // Horizontal shift: increases with distance (ladder effect)
                const horizontalShift = normalizedDistance * 180 - 50;

                item.style.opacity = Math.max(0.2, opacity);
                item.style.transformOrigin = 'left center';
                item.style.transform = `translateX(${horizontalShift}px) scale(${scale}) `;
                // item.innerHTML = offset; // debug offset
            });
        }

        flicking.on('move', setMobileStyles);
        // Wait for Flicking to fully initialize circular positioning
        flicking.once('ready', () => {
            // Force a tiny move to trigger circular repositioning
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setMobileStyles();
                });
            });

            // Show after flicking is ready
            setTimeout(() => {
                document.getElementById('our-features-flick').style.opacity = 1;
            }, 20);
        });

        return;
    }

    // Desktop animation
    const slidesInView = 7;
    flicking.on('move', setStyles);
    setStyles();
    function setStyles() {
        flicking.camera._visiblePanels.forEach((panel) => {
            const slidesAboveTheMain = (slidesInView - 1) / 2;
            const maxOffset = (flicking.camera.range.max / flicking.panels.length) * slidesAboveTheMain;
            const panelPos = panel._pos + panel._alignPos + panel.offset;
            const panelOffset = Math.abs(flicking.camera.position - panelPos);
            const offsetNormalized = panelOffset / maxOffset;
            panel._elProvider.element.style.setProperty('--offsetMultiplier', offsetNormalized);
            panel._elProvider.element.style.setProperty('--offsetMultiplierSquare', offsetNormalized * offsetNormalized);
        });
    }
}
